const DEFAULT_PRIVACY_URL = {
    en: 'https://centralio.com/en/privacy/',
    fr: 'https://centralio.com/confidentialite'
};
const DEFAULT_MARKETING_LABEL = {
    en: 'I agree to receive the newsletter by email.',
    fr: 'J’accepte de recevoir l’infolettre par courriel.'
};
function languageKey(language) {
    return (language === null || language === void 0 ? void 0 : language.toLowerCase().startsWith('en')) ? 'en' : 'fr';
}
function languageIndex(language) {
    return languageKey(language) === 'en' ? 0 : 1;
}
function parseConfigValue(field) {
    if (!(field === null || field === void 0 ? void 0 : field.value)) {
        return undefined;
    }
    const raw = field.value;
    let parsed = raw;
    if (typeof raw === 'string') {
        try {
            parsed = JSON.parse(raw);
        }
        catch (_a) {
            return undefined;
        }
    }
    return parsed === null || parsed === void 0 ? void 0 : parsed.value;
}
function translatableConfigValue(field, language) {
    var _a, _b, _c;
    const parsed = parseConfigValue(field);
    if (!parsed) {
        return '';
    }
    const key = languageKey(language);
    if ((_a = parsed.translations) === null || _a === void 0 ? void 0 : _a[key]) {
        return String(parsed.translations[key]).trim();
    }
    const indexed = (_c = (_b = parsed.value) === null || _b === void 0 ? void 0 : _b[languageIndex(language)]) === null || _c === void 0 ? void 0 : _c.translations;
    if (typeof indexed === 'string' && indexed.trim()) {
        return indexed.trim();
    }
    if (typeof parsed === 'string') {
        return parsed.trim();
    }
    return '';
}
export function getPrivacyConsentConfig(configurationFields, language) {
    const fields = configurationFields !== null && configurationFields !== void 0 ? configurationFields : [];
    const privacyField = fields.find((field) => field.fieldKey === 'PRIVACY_POLICY_URL');
    const collectField = fields.find((field) => field.fieldKey === 'COLLECT_MARKETING_CONSENT');
    const labelField = fields.find((field) => field.fieldKey === 'MARKETING_CONSENT_LABEL');
    const collectValue = parseConfigValue(collectField);
    const privacyPolicyUrl = translatableConfigValue(privacyField, language) ||
        DEFAULT_PRIVACY_URL[languageKey(language)];
    const marketingLabel = translatableConfigValue(labelField, language) ||
        DEFAULT_MARKETING_LABEL[languageKey(language)];
    return {
        collectMarketing: collectValue !== 'FALSE',
        marketingLabel,
        privacyPolicyUrl
    };
}
